import { render, staticRenderFns } from "./ItemSelectorCheckbox.vue?vue&type=template&id=97873dae&scoped=true"
import script from "./ItemSelectorCheckbox.vue?vue&type=script&lang=js"
export * from "./ItemSelectorCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97873dae",
  null
  
)

export default component.exports